import dayjs from 'dayjs';
import { TAB } from '../Constants/AnalyticsConstants';
import { getTimeFormatAccordingToPreference } from './DateUtils';

export const getSoloTeamType = (memberData: any) => {
  return memberData?.member?.userApplicationDetails?.[0]?.attributes?.SoloTeam === 'SNI Solo'
    ? 'Power Only'
    : 'Power Only,Power Only Team';
};

export const isAppointmentState = (stops: any[]) => {
  let appointmentStateValue = stops?.every((stop: any) => stop?.appointmentState === 'A');
  return appointmentStateValue;
};

export const filterStopAppointments = (loads: any[]) => {
  return loads?.filter((load: any) => isAppointmentState(load?.loadStop));
};

export const deadHeadValidation = (deadHead: any) => {
  if (
    deadHead === null ||
    deadHead === '0.0' ||
    deadHead === '0' ||
    deadHead === '0.00' ||
    deadHead === 0
  ) {
    return null;
  } else {
    return deadHead;
  }
};
export const isValidRPM = (rpm: any) => {
  if (rpm === null || rpm === '0.0' || rpm === '0' || rpm === '0.00' || rpm === 0) {
    return false;
  } else {
    return rpm || null;
  }
};

export const hasDeadHeadValue = (array: any[]) => {
  return array.some((element) => element !== null);
};

export const tabFinding = (_type: string | unknown) => {
  switch (_type) {
    case 'new':
      return TAB.NEW;
    case 'recent':
      return TAB.RECENT;
    case 'favorite':
      return TAB.FAVORITE;
    case 'watched':
      return TAB.WATCHED;
    default:
      return '';
  }
};

export const getMemberDetails = (memberData: any, isMobile: any) => {
  const userDetails = memberData?.member?.userApplicationDetails[0]?.attributes;
  const driverId = userDetails?.DriverId;
  const primaryBookingDriverId = userDetails?.PrimaryBookingDriverId;
  const isPrimaryBookingIdDifferent = primaryBookingDriverId !== driverId;

  const memberDetails = [
    {
      label: 'Driver ID',
      value: driverId,
    },
    {
      label: 'Email Address',
      value: memberData?.member?.email,
    },
    {
      label: 'Current Date / Time',
      value: `${dayjs().format(`ddd, MMM DD, YYYY / ${getTimeFormatAccordingToPreference(true)}`)} ${dayjs()
        .format('zzz')
        ?.split(' ')
        ?.map((word: string) => word[0])
        ?.join('')}`,
    },
  ];

  if (isPrimaryBookingIdDifferent) {
    const primaryDriverDetail = {
      label: 'Primary Driver ID',
      value: primaryBookingDriverId,
    };

    if (isMobile) {
      memberDetails.splice(1, 0, primaryDriverDetail);
    } else {
      memberDetails.push(primaryDriverDetail);
    }
  }

  return memberDetails;
};
